<template>
  <div class="boy_warp">
    <el-card style="height: 100%">
      <p>家庭户每户人员数量占比情况</p>
      <div ref="echartsINof" style="height: 100%"></div>
    </el-card>
  </div>
</template>

<script>
import { userFormmer } from "@/network";
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.getInfoFrmmes();
  },
  methods: {
    async getInfoFrmmes() {
      const { code, data } = await userFormmer({ type: 1 });
      if (code == 200) {
        this.handEchart(data);
      }
    },
    handEchart(dataV) {
      let myechart = this.$echarts.init(this.$refs.echartsINof);
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c}%",
        },

        toolbox: {
          feature: {
            dataView: { readOnly: false },
            restore: {},
            saveAsImage: {},
          },
        },
        legend: {
          data: [
            dataV.title,
            dataV.title2,
            dataV.title3,
            dataV.title4,
            dataV.title5,
            dataV.title6,
          ],
          orient: "vertical",
          right: 10,
          y: "center",
        },

        series: [
          {
            name: "家庭数量",
            type: "funnel",
            left: "10%",
            top: 60,
            bottom: 60,
            width: "80%",
            minSize: "10%",
            sort: "ascending", 
            label: {
              position: "left",
              fontSize: 12,
              formatter: function (params) {
              },
            },
            itemStyle: {
              borderColor: "#fff",
              borderWidth: 0,
            },
            emphasis: {
              label: {
                fontSize: 20, //悬停时文字大小
              },
            },
            data: [
              { value: dataV.cnt, name: dataV.title },
              { value: dataV.cnt2, name: dataV.title2 },
              { value: dataV.cnt3, name: dataV.title3 },
              { value: dataV.cnt4, name: dataV.title4 },
              // { value: dataV.cnt5, name: dataV.title5 },
              // { value: dataV.cnt6, name: dataV.title6 },
            ],
          },
        ],
      };
      myechart.setOption(option);
    },
  },
};
</script>

<style lang="less">
// .boy_warp {
//   width: 100%;
//   height: 100%;
//   overflow: hidden;
//   .el-card__body {
//     height: 100%;
//   }
// }
</style>
